import { render, staticRenderFns } from "./articles-group.vue?vue&type=template&id=f29a2e66"
import script from "./articles-group.vue?vue&type=script&lang=js"
export * from "./articles-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports